import {
  Box,
  Button,
  Stack,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import IntakeService from "./IntakeService";
import PersonSearchBox, { PersonId } from "./PersonSearchBox";
import { Checkbox } from "@mui/material";
import moment from "moment";
import { generateClient } from "aws-amplify/api";
import { SyncQuery } from "../../API";
import * as queries from "../../graphql/queries";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  checkedGreen: {
    color: "green !important",
  },
  checkedRed: {
    color: "red !important",
  },
  label: {
    display: "flex",
    alignItems: "center",
  },
  formControl: {
    width: "100%",
    marginBottom: "16px",
  },
  input: {
    color: "#000",
    "& .MuiInputLabel-outlined": {
      color: "#000",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000",
    },
    "& .MuiInputBase-input": {
      color: "#000",
    },
    "&.Mui-disabled": {
      color: "#000",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000",
      },
      backgroundColor: "#fff",
      "& .MuiInputBase-input": {
        color: "#000",
      },
    },
  },
  labelText: {
    color: "#000",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "16px",
    marginTop: "16px",
  },
  paper: {
    padding: "24px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  },
  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "8px",
  },
});

export interface Person {
  id: string;
  personType: string;
  firstName: string;
  lastName: string;
  mrn?: string;
  preferredName: string;
  dateOfBirth?: string;
  dateOfDeath?: string;
  dateOfLeaveStart?: string;
  dateOfLastLogin?: string;
  dateOfActivation?: string;
  dateOfActivationEnd?: string;
  dateOfFirstPing?: string;
  preferredFirstName: string;
  phone1?: string;
  phone2?: string;
  phone3?: string;
  preferred1: boolean;
  preferred2: boolean;
  preferred3: boolean;
  hidden1: boolean;
  hidden2: boolean;
  hidden3: boolean;
  type1: string;
  type2: string;
  type3: string;
  title?: string;
  email?: string;
  personalEmail: string;
  departmentName?: string;
  managerName?: string;
  locationCode?: string;
  community?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  aboutMe: string;
  birthPlace: string;
  favoriteThings: string;
  interests: string;
  profession: string;
  locked: boolean;
  activeCommunity: string;
  activeAdmissionId: string;
  gender: string;
  middleName: string;
  activeLevelOfCare: string;
  status: string;
  salesforceID: string;
  locationID: string;
  cell: string;
  firstAdmission: boolean;
  activeAdmission: boolean;
  activationStatus: boolean;
  active: boolean;
  description: string;
  balance: number;
  total: number;
  type: string;
  period: string;
  note: string;
  includeInDirectory: boolean;
  externalCalendarEnabled: boolean;
  fontSize: string;
}

const IntakeSearch = (props: RouteComponentProps) => {
  const [error, setError] = useState<string>("");

  const client = generateClient();
  const [selectedPerson, setSelectedPerson] = useState<Person | null>();

  const formatDate = (date?: string) => {
    return date ? moment(date.replace(/T.*/, "")).format("MM/DD/YYYY") : "";
  };

  const handlePersonSelect = async (person: PersonId) => {
    setSelectedPerson(null);
    const id: string = person.id;
    (await client.graphql({
      query: queries.sync,
      variables: { id },
    })) as GraphQLResult<SyncQuery>;
    const residentQuery = await IntakeService.getResident(person.id);
    console.log("resident query", residentQuery);

    const resident = residentQuery.data?.getResident;
    console.log("residetns", resident);

    if (resident) {
      setSelectedPerson({
        id: resident.id,
        firstName: resident.firstName || "",
        lastName: resident.lastName || "",
        mrn: resident.mrn || "",
        preferredName: resident.preferredName || "",
        // phone: resident.phone!,
        phone1: resident.contactInfo?.phones![0]?.value! || "",
        phone2: resident.contactInfo?.phones![1]?.value! || "",
        phone3: resident.contactInfo?.phones![2]?.value! || "",
        type1: resident.contactInfo?.phones![0]?.type || "",
        type2: resident.contactInfo?.phones![1]?.type || "",
        type3: resident.contactInfo?.phones![2]?.type || "",
        preferred1: resident.contactInfo?.phones![0]?.preferred!,
        preferred2: resident.contactInfo?.phones![1]?.preferred!,
        preferred3: resident.contactInfo?.phones![2]?.preferred!,
        hidden1: resident.contactInfo?.phones![0]?.hidden!,
        hidden2: resident.contactInfo?.phones![1]?.hidden!,
        hidden3: resident.contactInfo?.phones![2]?.hidden!,
        email: resident.email || "",
        personalEmail: resident.personalEmail || "",
        dateOfBirth: resident.birthDate || undefined,
        dateOfDeath: resident.deathDate || undefined,
        dateOfLeaveStart: resident.leaveStartDate || undefined,
        dateOfLastLogin: resident.lastLoginDateTime || undefined,
        dateOfActivation: resident.activationStartDate || undefined,
        dateOfActivationEnd: resident.activationEndDate || undefined,
        dateOfFirstPing: resident.pingAccessStartDate || undefined,
        community: resident.community || undefined,
        addressLine1: resident.address?.addressLine1 || undefined,
        addressLine2: resident.address?.addressLine2 || undefined,
        city: resident.address?.city || undefined,
        state: resident.address?.state || undefined,
        zipcode: resident.address?.zipcode || undefined,
        aboutMe: resident.profile?.aboutMe || "",
        birthPlace: resident.profile?.birthPlace || "",
        favoriteThings: resident.profile?.favoriteThings || "",
        interests: resident.profile?.interests || "",
        profession: resident.profile?.profession || "",
        locked: resident.locked!,
        activeCommunity: resident.activeCommunity || "",
        activeAdmissionId: resident.activeAdmissionId || "",
        gender: resident.gender || "",
        middleName: resident.middleName || "",
        activeLevelOfCare: resident.activeLevelOfCare || "",
        status: resident.status || "",
        personType: resident.personType || "",
        salesforceID: resident.salesforceID || "",
        locationID: resident.locationID || "",
        cell: resident.cell || "",
        preferredFirstName: resident.preferredFirstName || "",
        firstAdmission: resident.firstAdmission!,
        activeAdmission: resident.activeAdmission!,
        activationStatus: resident.activationStatus!,
        active: resident.active!,
        description: resident.customData?.mealPlan?.description || "",
        balance: resident.customData?.mealPlan?.balance!,
        total: resident.customData?.mealPlan?.total!,
        type: resident.customData?.mealPlan?.type || "",
        title: resident.customData?.mealPlan?.title || "",
        period: resident.customData?.mealPlan?.period || "",
        note: resident.note || "",
        includeInDirectory: resident.profile?.includeInDirectory!,
        externalCalendarEnabled: resident.profile?.externalCalendarEnabled!,
        fontSize: resident.preferences?.fontSize || "",
      });
    }
  };

  const handleNavigateToForm = () => {
    if (selectedPerson) {
      props.history.push(`/intake-form/${selectedPerson.id}/pui`);
    }
  };

  const handleNavigateToOther = () => {
    if (selectedPerson) {
      props.history.push(`/edit/${selectedPerson.id}`);
    }
  };

  const handleAddStaff = () => {
    props.history.push("/add");
  };

  function generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 =
      (typeof performance !== "undefined" &&
        performance.now &&
        performance.now() * 1000) ||
      0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  const handleNavigateToAdd = () => {
    handleAddStaff();
    generateUUID();
  };
  const [personType, setPersonType] = useState();
  const classes = useStyles();

  const handlePersonTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPersonType(personType);
  };
  return (
    <React.Fragment>
      <p style={{ color: "red" }} hidden={!error}>
        An error has occurred: {error}
      </p>

      <Typography variant="h1" gutterBottom>
        Search
      </Typography>

      <br />

      <FormControl component="fieldset">
        <FormLabel component="legend">Person type</FormLabel>
        <RadioGroup row onChange={handlePersonTypeChange} value={personType}>
          <FormControlLabel control={<Radio />} label="Resident" />
        </RadioGroup>
      </FormControl>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={8} md={6}>
          {/* <PersonSearchBox personType={personType} onSelect={handlePersonSelect} /> */}
          <PersonSearchBox onSelect={handlePersonSelect} />
        </Grid>
      </Grid>

      {selectedPerson && (
        <Box mt={2}>
          <h2>Information</h2>

          <Grid container spacing={3} style={{ marginBottom: "16px" }}>
            {[
              { label: "Active", value: selectedPerson.active },
              {
                label: "Activation Status",
                value: selectedPerson.activationStatus,
              },
              { label: "Locked", value: selectedPerson.locked },
              {
                label: "First Admission",
                value: selectedPerson.firstAdmission,
              },
              {
                label: "Active Admission",
                value: selectedPerson.activeAdmission,
              },
              {
                label: "Include In Directory",
                value: selectedPerson.includeInDirectory,
              },
              {
                label: "Calendar Enabled",
                value: selectedPerson.externalCalendarEnabled,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(item.value)}
                      // className={item.value ? classes.checked : ""}
                      className={
                        item.label === "Locked"
                          ? item.value
                            ? classes.checkedRed
                            : ""
                          : item.value
                          ? classes.checkedGreen
                          : ""
                      }
                    />
                  }
                  label={item.label}
                  classes={{ root: classes.label }}
                />
              </Grid>
            ))}
          </Grid>

          <Grid container spacing={3}>
            {[
              { label: "Person Type", value: selectedPerson.personType },
              { label: "ID", value: selectedPerson.id },
              { label: "Sales Force ID", value: selectedPerson.salesforceID },
              { label: "First Name", value: selectedPerson.firstName },
              { label: "Middle Name", value: selectedPerson.middleName },
              { label: "Last Name", value: selectedPerson.lastName },
              { label: "Community", value: selectedPerson.community },
              {
                label: "Active Community",
                value: selectedPerson.activeCommunity,
              },
              {
                label: "Active Admission ID",
                value: selectedPerson.activeAdmissionId,
              },
              {
                label: "MRN",
                value: selectedPerson.mrn,
              },

              {
                label: "Date of Activation",
                value: formatDate(selectedPerson.dateOfActivation),
              },
              {
                label: "Activation End Date",
                value: formatDate(selectedPerson.dateOfActivationEnd),
              },
              {
                label: "Ping Access Date",
                value: selectedPerson.dateOfFirstPing
                  ? new Date(selectedPerson.dateOfFirstPing).toUTCString()
                  : "",
              },
              {
                label: "Leave Start Date",
                value: formatDate(selectedPerson.dateOfLeaveStart),
              },
              {
                label: "Last Login Date",
                value: selectedPerson.dateOfLastLogin
                  ? new Date(selectedPerson.dateOfLastLogin).toUTCString()
                  : "",
              },
              { label: "Gender", value: selectedPerson.gender },
              { label: "Preferred Name", value: selectedPerson.preferredName },
              {
                label: "Preferred First Name",
                value: selectedPerson.preferredFirstName,
              },
              {
                label: "Date of Birth",
                value: formatDate(selectedPerson.dateOfBirth),
              },
              {
                label: "Death Date",
                value: formatDate(selectedPerson.dateOfDeath),
              },
              {
                label: "Active Level of Care",
                value: selectedPerson.activeLevelOfCare,
              },
              {
                label: "Location ID",
                value: selectedPerson.locationID,
              },
              {
                label: "Status",
                value: selectedPerson.status,
              },
              {
                label: "Birth Place",
                value: selectedPerson.birthPlace,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <FormControl className={classes.formControl} variant="outlined">
                  <InputLabel
                    htmlFor={`field-${index}`}
                    className={classes.labelText}
                    shrink={true} // Keeps the label floating above the input
                  >
                    {item.label}
                  </InputLabel>
                  <OutlinedInput
                    id={`field-${index}`}
                    value={item.value || ""} // Ensures input is empty if no value
                    label={item.label}
                    readOnly
                    className={classes.input}
                    notched={true} // Ensures the notch is always present
                  />
                </FormControl>
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={3} style={{ marginBottom: "16px" }}>
            {/* Outer container for consistent spacing */}
            <Grid item xs={12}>
              {/* Title of the box, styled separately */}
              <Typography variant="h6" className={classes.title}>
                Meal Information
              </Typography>

              {/* Create a box using Paper for consistent style */}
              <Paper className={classes.paper}>
                {/* Container for fields inside the Meal Information box */}
                <Grid container spacing={3}>
                  {[
                    { label: "Meal Type", value: selectedPerson.type },
                    { label: "Meal Title", value: selectedPerson.title },
                    { label: "Description", value: selectedPerson.description },
                    { label: "Balance", value: String(selectedPerson.balance) },
                    { label: "Total", value: String(selectedPerson.total) },
                    { label: "Period", value: selectedPerson.period },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                        fullWidth
                      >
                        <InputLabel
                          htmlFor={`meal-field-${index}`}
                          className={classes.labelText}
                          shrink={true}
                        >
                          {item.label}
                        </InputLabel>
                        <OutlinedInput
                          id={`meal-field-${index}`}
                          value={item.value || ""}
                          label={item.label}
                          readOnly
                          className={classes.input}
                          notched={true}
                        />
                      </FormControl>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          <Typography variant="h6" className={classes.title}>
            Address Information
          </Typography>
          <Paper className={classes.paper} style={{ marginBottom: "16px" }}>
            <Grid container spacing={3}>
              {/* First row for Address and Address Line 2 */}
              <Grid container item xs={12} spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <InputLabel
                      htmlFor="address"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Address
                    </InputLabel>
                    <OutlinedInput
                      id="address"
                      value={selectedPerson.addressLine1 || ""}
                      label="Address"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <InputLabel
                      htmlFor="address-line-2"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Address Line 2
                    </InputLabel>
                    <OutlinedInput
                      id="address-line-2"
                      value={selectedPerson.addressLine2 || ""}
                      label="Address Line 2"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/* Second row for City, State, and Zip Code */}
              <Grid container item xs={12} spacing={3}>
                <Grid item xs={12} sm={4}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <InputLabel
                      htmlFor="city"
                      className={classes.labelText}
                      shrink={true}
                    >
                      City
                    </InputLabel>
                    <OutlinedInput
                      id="city"
                      value={selectedPerson.city || ""}
                      label="City"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <InputLabel
                      htmlFor="state"
                      className={classes.labelText}
                      shrink={true}
                    >
                      State
                    </InputLabel>
                    <OutlinedInput
                      id="state"
                      value={selectedPerson.state || ""}
                      label="State"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                  >
                    <InputLabel
                      htmlFor="zipcode"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Zip Code
                    </InputLabel>
                    <OutlinedInput
                      id="zipcode"
                      value={selectedPerson.zipcode || ""}
                      label="Zip Code"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Typography variant="h5" className={classes.sectionTitle}>
            Contact Information
          </Typography>
          <Paper className={classes.paper} style={{ marginBottom: "20px" }}>
            <Grid container spacing={3}>
              {/* Row for Type 1, Phone 1, Preferred 1, and Hidden 1 */}
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="type1"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Type
                    </InputLabel>
                    <OutlinedInput
                      id="type1"
                      value={selectedPerson.type1 || ""}
                      label="Type 1"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="phone1"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Phone
                    </InputLabel>
                    <OutlinedInput
                      id="phone1"
                      value={selectedPerson.phone1 || ""}
                      label="Phone 1"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.preferred1)} />
                    }
                    label="Preferred"
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.hidden1)} />
                    }
                    label="Hidden"
                  />
                </Grid>
              </Grid>

              {/* Row for Type 2, Phone 2, Preferred 2, and Hidden 2 */}
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="type2"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Type
                    </InputLabel>
                    <OutlinedInput
                      id="type2"
                      value={selectedPerson.type2 || ""}
                      label="Type 2"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="phone2"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Phone
                    </InputLabel>
                    <OutlinedInput
                      id="phone2"
                      value={selectedPerson.phone2 || ""}
                      label="Phone 2"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.preferred2)} />
                    }
                    label="Preferred"
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.hidden2)} />
                    }
                    label="Hidden"
                  />
                </Grid>
              </Grid>

              {/* Row for Type 3, Phone 3, Preferred 3, and Hidden 3 */}
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="type3"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Type
                    </InputLabel>
                    <OutlinedInput
                      id="type3"
                      value={selectedPerson.type3 || ""}
                      label="Type 3"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="phone3"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Phone
                    </InputLabel>
                    <OutlinedInput
                      id="phone3"
                      value={selectedPerson.phone3 || ""}
                      label="Phone 3"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.preferred3)} />
                    }
                    label="Preferred"
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={Boolean(selectedPerson.hidden3)} />
                    }
                    label="Hidden"
                  />
                </Grid>
              </Grid>

              {/* Row for Cell */}
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={3}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="cell"
                      className={classes.labelText}
                      shrink={true}
                    >
                      Cell
                    </InputLabel>
                    <OutlinedInput
                      id="cell"
                      value={selectedPerson.cell || ""}
                      label="Cell"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              {/* Row for MyUnity Email and TouchTown Email */}
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={6}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="personalEmail"
                      className={classes.labelText}
                      shrink={true}
                    >
                      MyUnity Email
                    </InputLabel>
                    <OutlinedInput
                      id="personalEmail"
                      value={selectedPerson.personalEmail || ""}
                      label="MyUnity Email"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor="email"
                      className={classes.labelText}
                      shrink={true}
                    >
                      TouchTown Email
                    </InputLabel>
                    <OutlinedInput
                      id="email"
                      value={selectedPerson.email || ""}
                      label="TouchTown Email"
                      readOnly
                      className={classes.input}
                      notched={true}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          <Typography variant="h6" className={classes.title}>
            Profile Information
          </Typography>
          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              {[
                {
                  label: "About me",
                  value: selectedPerson.aboutMe,
                  id: "address",
                },
                {
                  label: "Favorite Things",
                  value: selectedPerson.favoriteThings,
                  id: "address-line-2",
                },
                {
                  label: "Interests",
                  value: selectedPerson.interests,
                  id: "city",
                },
                {
                  label: "Profession",
                  value: selectedPerson.profession,
                  id: "state",
                },
              ].map((item, index) => (
                <Grid item xs={12} key={index}>
                  <FormControl
                    className={classes.formControl}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel
                      htmlFor={item.id}
                      className={classes.labelText}
                      shrink={true}
                    >
                      {item.label}
                    </InputLabel>
                    <OutlinedInput
                      id={item.id}
                      value={item.value || ""}
                      label={item.label}
                      readOnly
                      className={classes.input}
                      notched={true}
                      multiline
                      minRows={1}
                      maxRows={4}
                      inputProps={{
                        style: { overflow: "hidden" }, // Hide scrollbar
                      }}
                    />
                  </FormControl>
                </Grid>
              ))}
            </Grid>
          </Paper>

          <Grid marginTop={2}>
            <Typography variant="h6">{"Note:"}</Typography>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              justifyContent="center"
              className={classes.label}
            ></Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
            >
              <TextField
                id="outlined-multiline-flexible"
                fullWidth
                multiline
                maxRows={4}
                variant="outlined"
                placeholder="Please write a reason for a change or an update"
                value={selectedPerson?.note || ""}
                // onBlur={event => handleInputBlur('address', event.target.value as string)}
              />
            </Grid>
          </Grid>

          <Grid container style={{ position: "relative", marginTop: "1%" }}>
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                // style={{ position: "absolute", left: "17%" }}
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Button
                  onClick={handleNavigateToOther}
                  color="success"
                  variant="contained"
                >
                  {"Update"}
                </Button>

                <Button
                  onClick={handleNavigateToAdd}
                  color="success"
                  variant="contained"
                >
                  {"Add Staff"}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};

export default withRouter(IntakeSearch);
